export const GROWTH_BOOK_API_HOST = process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST as string;
export const GROWTH_BOOK_CLIENT_KEY = process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY as string;
export const GROWTH_BOOK_DECRYPTION_KEY = process.env.NEXT_PUBLIC_GROWTHBOOK_DECRYPTION_KEY as string;
